import operations from '~/helpers/device-operations';
import { migrated, subtype, zigBeeAddress } from '~/helpers/fields-description';
import { Operation } from '~/interfaces/device.interface';
import { LegrandGateway } from './LegrandGateway.model';

export class BNMH extends LegrandGateway {

    MAX_TIME_BEFORE_UNKNOWN = 6 * 3600;

    migrated?: boolean;

    get deviceOperations(): Operation[] {
        const deviceOperations = super.deviceOperations.concat([
            operations.resetMigrationFlag({ callback: this.resetMigrationFlag }),
            operations.resetMigrationSecret({ callback: this.resetMigrationSecret }),
            operations.triggerLogsDump({ callback: this.triggerLogsDump }),
            operations.rollbackMigration({ callback: this.rollbackMigration }),
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
        ]);
        if (this.homeId) {
            deviceOperations.push(operations.getLocalResources({ callback: this.getLocalResources }));
        }
        return deviceOperations;
    }

    get fieldZigBeeAddress() {
        return zigBeeAddress(this.zigbee_address);
    }

    get fieldSubtype() {
        return subtype(this.subtype);
    }

    get fieldMigrated() {
        return migrated(this.migrated);
    }


}
